import { useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { IRollingAerValues } from '../../../../greenTypes';
import { AgChartOptions } from 'ag-charts-community';
import { formatValueAsString } from '../../../../../../utils/helpers';
import { ChartContainer } from '../../../../../../shared/components/charts/ChartContainer';

interface IAerChartProps {
	data: IRollingAerValues[] | undefined;
}

const AerChart: React.FC<IAerChartProps> = ({ ...props }) => {
	const formatOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

	const data = props.data;

	const [options] = useState<AgChartOptions>({
		data: data,
		series: [
			{
				type: 'area',
				xKey: 'signalDateTime',
				yKey: 'aValue',
				yName: 'A',
				stacked: true,
				fill: '#00af50',
			},
			{
				type: 'area',
				xKey: 'signalDateTime',
				yKey: 'bValue',
				yName: 'B',
				stacked: true,
				fill: '#92d14f',
			},
			{
				type: 'area',
				xKey: 'signalDateTime',
				yKey: 'cValue',
				yName: 'C',
				stacked: true,
				fill: '#ffc000',
			},
			{
				type: 'area',
				xKey: 'signalDateTime',
				yKey: 'dValue',
				yName: 'D',
				stacked: true,
				fill: '#ed7d31',
			},
			{
				type: 'area',
				xKey: 'signalDateTime',
				yKey: 'eValue',
				yName: 'E',
				stacked: true,
				fill: '#c00000',
			},
			{
				type: 'line',
				xKey: 'signalDateTime',
				yKey: 'rollingCiiScore',
				yName: 'CII Score',
				stroke: '#000000',
				strokeWidth: 2,
				marker: {
					enabled: false,
				},
			},
		],
		axes: [
			{
				type: 'category',
				position: 'bottom',
				label: {
					rotation: -90,
					formatter: (params: any) => {
						const date = new Date(params.value);
						return date.toLocaleString('default', { month: 'short', year: 'numeric' });
					},
				},
				tick: {
					size: 6,
					enabled: true,
				},
			},
			{
				type: 'number',
				position: 'left',
				nice: false,
				title: {
					text: 'gCO₂/dwt.nm',
				},
				label: {
					formatter: (params: any) => {
						return formatValueAsString(params.value, formatOptions, '-', '', '');
					},
				},
			},
		],
		legend: {
			position: 'bottom',
			item: {
				label: {
					fontSize: 12,
				},
				marker: {
					size: 12,
				},
			},
			spacing: 10,
		},
	});

	return (
		<ChartContainer 
			data={options.data} 
			filename="rolling_aer_values"
			buttonPosition="top-right"
		>
			<AgCharts options={options} className="w-full h-full" />
		</ChartContainer>
	);
};

export default AerChart;
